/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import * as _ from 'lodash'
import { ClikProjectInfo } from '../../types/clik/ClikProjectInfo'
import { HttpClient } from '@angular/common/http'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-clik-client-configuration',
    templateUrl: './clikclientconfiguration.component.html',
    styleUrls: ['./clikclientconfiguration.component.less'],
})
export class ClikclientconfigurationComponent implements OnInit {
    @Output() changeEvent = new EventEmitter<ClikProjectInfo>()

    constructor(private $http: HttpClient, private modalService: NgbModal) {}

    @Input() clikConfigurationName: any

    public info = new ClikProjectInfo()
    public options: any = {
        projectOptions: [],
        tagOptions: [],
    }

    ngOnInit(): void {
        let vm = this

        vm.info.configurationName = vm.clikConfigurationName

        Promise.all([vm.currentProject(), vm.currentTag()]).then(function (results: any[]) {
            vm.info.projectName = results[0].project_name
            vm.info.tagName = results[1].tag_name

            console.log(vm.info)

            if (vm.info.projectName) {
                vm.getTagOptions()
            }

            // Emit the initial state
            vm.changeEvent.emit(vm.info)
        })

        vm.getProjectOptions()
    }

    projects() {
        let vm = this
        return vm.$http
            .get('/api/clik/' + vm.clikConfigurationName + '/projects')
            .toPromise()
            .then(
                function (result: any) {
                    console.debug('Got Good response for projects' + JSON.stringify(result))
                    return result.records
                },
                function (result) {
                    console.debug('Got Bad Result for projects')
                    return []
                }
            )
    }

    tags(projectName: string) {
        let vm = this
        return vm.$http
            .get('/api/clik/' + vm.clikConfigurationName + '/tags?project_name=' + encodeURIComponent(projectName))
            .toPromise()
            .then(
                function (result: any) {
                    console.debug('Got Good response for tags' + JSON.stringify(result))
                    return result.records
                },
                function (result: any) {
                    console.debug('Got Bad Result for tags')
                    return []
                }
            )
    }

    currentProject(projectName?: string) {
        let vm = this
        let promise
        if (projectName) {
            promise = vm.$http
                .put('/api/clik/' + vm.clikConfigurationName + '/project/' + encodeURIComponent(projectName), null)
                .toPromise()
        } else {
            promise = vm.$http.get('api/clik/' + vm.clikConfigurationName + '/project').toPromise()
        }
        promise = promise.then(
            function (result: any) {
                console.debug('Got Good response for project ' + JSON.stringify(result))
                return result
            },
            function (result: any) {
                console.debug('Got Bad Result for project')
                vm.showError(result)
                return {}
            }
        )
        return promise
    }

    currentTag(tagName?: string | null) {
        let vm = this
        let promise
        if (tagName !== undefined) {
            promise = vm.$http
                .put('/api/clik/' + vm.clikConfigurationName + '/tag/' + encodeURIComponent(tagName || ''), null)
                .toPromise()
        } else {
            promise = vm.$http.get('api/clik/' + vm.clikConfigurationName + '/tag').toPromise()
        }
        promise = promise.then(
            function (result: any) {
                console.debug('Got Good response for tag ' + JSON.stringify(result))
                return result
            },
            function (result: any) {
                console.debug('Got Bad Result for tag')
                vm.showError(result)
                return {}
            }
        )
        return promise
    }

    projectChange() {
        let vm = this
        let val = vm.info.projectName
        if (val) {
            console.debug('Setting Project Name for configuration=' + vm.clikConfigurationName + ', project=' + val)
            //$scope.info.projectName = val;
            vm.currentProject(val).then(function (response) {
                vm.info.projectName = response.project_name

                // Clear the tag if the project changes
                vm.info.tagName = null
                vm.tagChange()

                vm.getTagOptions()
            })
        }
        return vm.info.projectName
    }

    getProjectOptions() {
        let vm = this
        vm.projects()
            .then(function (projects: any) {
                console.debug(
                    'Got Projects for configuration=' +
                        vm.clikConfigurationName +
                        ', projects=' +
                        JSON.stringify(projects)
                )
                vm.options.projectOptions = projects
                return projects
            })
            .then(function (projects: any) {
                _.each(projects, function (proj) {
                    proj.display_label = proj.project_name
                    if (proj.project_description) {
                        proj.display_label += ' - ' + proj.project_description
                    }
                })
                // Push the 'no project' to the front.
                projects.unshift({ project_name: null, display_label: 'Default' })
                if (0 < projects.length) {
                    if (!vm.info.projectName) {
                        console.debug('selecting project: ' + projects[0].project_name)
                        vm.info.projectName = projects[0].project_name // this value should already be in context
                    }
                }
                vm.options.projectOptions = projects
            })
    }

    getTagOptions() {
        let vm = this
        vm.tags(vm.info.projectName)
            .then(function (tags: any) {
                console.debug('Got tags: ' + JSON.stringify(tags))
                _.each(tags, function (tag) {
                    tag.display_label = tag.tag_name
                })
                vm.options.tagOptions = tags
                return tags
            })
            .then(function (tags: any) {
                // Push the 'no tag' to the front.
                tags.unshift({ tag_name: null, display_label: 'None' })
                if (0 < tags.length) {
                    if (!vm.info.tagName) {
                        console.debug('selecting tag: ' + tags[0].tag_name)
                        vm.info.tagName = tags[0].tag_name // this value should already be in context
                    }
                }
                vm.options.tagOptions = tags
            })
    }

    tagChange() {
        let vm = this
        let val = vm.info.tagName
        console.debug('Setting Tag Name ' + val)
        //vm.info.tagName = val;
        vm.currentTag(val).then(function (response) {
            vm.info.tagName = response?.tag_name
            vm.changeEvent.emit(vm.info)
        })
        return vm.info.tagName
    }

    showError(result: any) {
        let vm = this
        vm.modalService.open({
            component: 'BusydialogComponent',
            backdrop: 'static',
            resolve: {
                errorTitle: function () {
                    return 'Error'
                },
                result: function () {
                    return {
                        value: new Promise(function (resolve, reject) {
                            reject({
                                error: 'Data Manager Error:',
                                messages: [result.message],
                            })
                        }),
                    }
                },
            },
        })
    }
}
